import { render, staticRenderFns } from "./SleepUserWakeUp.vue?vue&type=template&id=023138f7&scoped=true&"
import script from "./SleepUserWakeUp.vue?vue&type=script&lang=js&"
export * from "./SleepUserWakeUp.vue?vue&type=script&lang=js&"
import style0 from "./SleepUserWakeUp.vue?vue&type=style&index=0&id=023138f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023138f7",
  null
  
)

export default component.exports